import { render, staticRenderFns } from "./CheckboxButtonQuestion.vue?vue&type=template&id=07c59869&scoped=true&"
import script from "./CheckboxButtonQuestion.vue?vue&type=script&lang=js&"
export * from "./CheckboxButtonQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxButtonQuestion.vue?vue&type=style&index=0&id=07c59869&prod&scoped=true&lang=css&"
import style1 from "./CheckboxButtonQuestion.vue?vue&type=style&index=1&id=07c59869&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c59869",
  null
  
)

export default component.exports